module.exports = __webpack_public_path__ + "static/img/img_solution_12.d2ddfc7.png";


//////////////////
// WEBPACK FOOTER
// ./static/mobile/msolution/img_solution_12.png
// module id = 3cPu
// module chunks = 0